import React from 'react'
import classNames from 'classnames'

import './Button.css'

const GetADemoButton = ({ ...props }) => {
  const classes = classNames('c-button', props.className || 'mt-8 self-center')

  return (
    <a href='/demo' className={classes}>
      Get a Demo
    </a>
  )
}

export default GetADemoButton
